import { IngredientType } from '@libs/trip-planner-interfaces';
import type { TransportVehicleType } from '@libs/trip-planner-interfaces';

import type { TransportIngredientFilters } from './transportIngredient';
import { TransportIngredient } from './transportIngredient';

export type FerryIngredientFilters = TransportIngredientFilters;

export interface Port {
  iata: string;
  displayingText: string;
}

export class FerryIngredient extends TransportIngredient {
  public static get defaultFilters(): FerryIngredientFilters {
    return {
      ...TransportIngredient.defaultFilters,
    };
  }

  public vehicles: TransportVehicleType[] = [];
  public allowMultipleVehicles = false;
  public allowVehicles = true;
  public fromPortCountry?: string;
  public toPortCountry?: string;

  public filters: FerryIngredientFilters = FerryIngredient.defaultFilters;

  constructor() {
    super(IngredientType.Ferry);
  }

  public setPorts(fromPort: Port, toPort: Port): void {
    this.transportIds = [];

    this.fromPort = fromPort.iata;
    this.fromPortDisplayText = fromPort.displayingText;

    this.toPort = toPort.iata;
    this.toPortDisplayText = toPort.displayingText;
  }

  public resetFerryIngredientFilters(): void {
    this.transportIds = [];

    this.filters = FerryIngredient.defaultFilters;
  }

  public setVehicles(vehicles: TransportVehicleType[]): void {
    this.vehicles = vehicles;
  }

  public setAllowMultipleVehicles(allowMultipleVehicles: boolean): void {
    this.allowMultipleVehicles = allowMultipleVehicles;
  }

  public setAllowVehicles(allowVehicles: boolean): void {
    this.allowVehicles = allowVehicles;
  }

  public setPortCountry(fromPortCountry: string, toPortCountry: string): void {
    this.fromPortCountry = fromPortCountry;
    this.toPortCountry = toPortCountry;
  }
}
